module.exports = __webpack_public_path__ + "img/pointer-02.1fb97e05.png";